import { render, staticRenderFns } from "./PublicTagList.vue?vue&type=template&id=02e5b850&scoped=true"
import script from "./PublicTagList.vue?vue&type=script&lang=js"
export * from "./PublicTagList.vue?vue&type=script&lang=js"
import style0 from "./PublicTagList.vue?vue&type=style&index=0&id=02e5b850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e5b850",
  null
  
)

export default component.exports